export const validateTheme = (theme: string): string => {
  const supportedThemes = ['oddschecker', 'widget'];

  if (!supportedThemes.includes(theme)) {
    return 'oddschecker';
  }

  return theme;
};
